import React from 'react'
import IconBase from '../IconBase'

const svgContent = <svg viewBox="0 0 1024 1024" width="1em" height="1em" focusable="false" fill="currentColor" aria-hidden="true"><path d="M0 512a320 320 0 1 0 640 0 320 320 0 1 0-640 0Z" fill="#23CFE6" /><path d="M384 512a320 320 0 1 0 640 0 320 320 0 1 0-640 0Z" fill="#3491FA" opacity={0.8} /></svg>

const TitleDot = React.forwardRef((props, ref) => {
  return (
    <IconBase name="title-dot" {...props} ref={ref}>
      {svgContent}
    </IconBase>
  )
})

TitleDot.displayName = 'IconTitleDot'

export default TitleDot
